import 'moment/locale/id'
import * as ExcelJS from 'exceljs'
import moment from 'moment'
import { Merchant } from '../../interfaces/Merchant'
import 'moment-duration-format'
import { UserModel } from '../../app/modules/auth/models/UserModel'
import { CRMColumnDef } from '../../components/DataTable/MasterDataTableTanstack'
import { currencyFormatter, sortColumnDatatable } from '../general'
import { IntlShape } from 'react-intl'
import { CustomField, SettingMultiMerchants } from '../../interfaces/Settings'

const formatCustomField = (row: any, field: string, type: string, user: UserModel) => {
  const valueInfoCustomFields =
    row.info_custom_fields && row.info_custom_fields[field] ? row.info_custom_fields[field] : []
  const value = row.customFields[field]
  if (type === 'meeting')
    return valueInfoCustomFields.length > 0
      ? valueInfoCustomFields
        .map(
          (item: any) =>
            `${item.merchant_name} / ${moment(item.date_meet).format('DD MMM YYYY')} / ${item.meeting_status
            }`
        )
        .join(', ')
      : '-'
  else if (type === 'pipeline')
    return valueInfoCustomFields.length > 0
      ? valueInfoCustomFields
        .map(
          (item: any) =>
            `${item.name} / ${currencyFormatter(
              item.nominal,
              user?.data?.companyCurrencyNeedRound,
              user?.data?.companyCurrency,
              { showPrefix: true }
            )} / ${moment(item.dateStarted).format('DD MMM YYYY')}`
        )
        .join(', ')
      : '-'
  else if (type === 'merchant')
    return valueInfoCustomFields.length > 0
      ? valueInfoCustomFields.map((item: any) => item.merchant_name).join(', ')
      : '-'
  else if (type === 'user') {
    return valueInfoCustomFields.length > 0
      ? valueInfoCustomFields.map((item: any) => item.name).join(', ')
      : '-'
  } else if (type === 'invoice_reminder') {
    const parsedValue = JSON.parse(value)
    return [
      parsedValue.invoice_url,
      parsedValue.date_due ? moment(parsedValue.date_due).format('DD MMM YYYY') : '-',
    ]
  } else if (type === 'date') {
    return value ? moment(value).format('YYYY-MM-DD') : '-'
  } else if (type === 'dateTime') {
    return value ? moment(value).format('YYYY-MM-DD HH:mm') : '-'
  } else if (type === 'multiple' || type === 'multipleOption') {
    return value ? value.toString().split(',').join(', ') : '-'
  } else if (type === 'images' || type === 'files' || type === 'videos') {
    return value ? value.toString().split(',').join('\n ') : '-'
  } else if (type === 'serial') {
    return value ? value.join('') : '-'
  } else if (type === 'dateTimeRange') {
    return value
      ? typeof value === 'string'
        ? value
          .split(',')
          .map((item: any) => moment(item).format('YYYY-MM-DD HH:mm'))
          .join(' - ')
        : Array.isArray(value)
          ? value.map((item: any) => moment(item).format('YYYY-MM-DD HH:mm')).join(' - ')
          : value
      : '-'
  } else if (type === 'time') {
    return value
      ? typeof value === 'string'
        ? value
          .split(',')
          .map((item: any) => moment(item).format('HH:mm'))
          .join(' - ')
        : Array.isArray(value)
          ? value.map((item: any) => moment(item).format('HH:mm')).join(' - ')
          : value
      : '-'
  } else if (type === 'product')
    return valueInfoCustomFields.length > 0
      ? valueInfoCustomFields.map((item: any) => item.product_name).join(', ')
      : '-'
  else {
    return value
  }
}

const styleColumns = (
  worksheet: ExcelJS.Worksheet,
  indexRow: number,
) => {
  worksheet.getRow(indexRow).alignment = {
    vertical: 'middle',
    horizontal: 'center',
    wrapText: true,
  }
  worksheet.getRow(indexRow).eachCell(function (cell) {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: 'F6991D',
      },
    }
  })
  worksheet.getRow(indexRow).font = {
    name: 'Arial Black',
    size: 10,
    bold: true,
  }
  worksheet.getRow(indexRow + 1).eachCell(function (cell) {
    cell.fill = {
      type: 'pattern',
      pattern: 'solid',
      fgColor: {
        argb: 'F8B219',
      },
    };
  });
}

const exportWorkbook = async (workbook: ExcelJS.Workbook, source: string, fileName: string) => {

  workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.href = url
    a.download = fileName
    a.click()
  })

}


export const exportExcelReimbursement = async (
  nameFile: string,
  source: string,
  nameHeader: any,
  param: any,
  selectMultiMerchant: any,
  intl: IntlShape,
  data?: any[],
  columns?: CRMColumnDef<Merchant>[],
  user?: UserModel,
) => {
  let exportData: any[] = []
  var arrayCustomFieldReimbursement =
    Object.keys(selectMultiMerchant).length !== 0 ? selectMultiMerchant.customFields : []

  let comapnyCodeIndex = -1
  let comapnyNameIndex = -1
  let nameIndex1 = -1
  let nameIndex2 = -1

  const workbook = createWorkbook()
  const worksheet = createWorksheet(workbook, source)

  const getStatus = (approvalStatus: string) => {
    switch (approvalStatus) {
      case 'REJECTED':
        return intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.REJECTED' })
      case 'APPROVED':
        return intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.APPROVED' })
      case 'PAID_OFF':
        return intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.PAID_OFF' })
      default:
        return intl.formatMessage({ id: 'REIMBURSEMENT.STATUS.PENDING' })
    }
  }

  const returnSubHeader = () => {
    return Object.keys(arrayCustomFieldReimbursement).map((field: any) => {
      if (arrayCustomFieldReimbursement[field].type === 'date') return 'Format (YYYY-MM-DD)'
      else if (arrayCustomFieldReimbursement[field].type === 'dateTime') return 'Format (YYYY-MM-DD HH:mm)'
      else if (arrayCustomFieldReimbursement[field].type === 'dateTimeRange') return 'Format (YYYY-MM-DD HH:mm - YYY-MM-DD HH:mm)'
      else if (arrayCustomFieldReimbursement[field].type === 'time') return 'Format (HH:mm)'
      else return ''
    })
  }

  var header = [...nameHeader.reimbursement.header, ...Object.keys(arrayCustomFieldReimbursement).map((field: any) => arrayCustomFieldReimbursement[field].name)]
  var subHeader = [...nameHeader.reimbursement.subHeader, ...returnSubHeader()]

  worksheet.getRow(1).values = header
  worksheet.getRow(2).values = subHeader

  if (!data) return console.error(`Data ${source} - Export is empty`)

  Array.from(data!).map((row) => {
    var temp_excel = []
    temp_excel.push(
      moment(row.dateCreated).format('YYYY-MM-DD HH:mm:ss'),
      row.name,
      row.categoryName,
      row.value,
      row.userOwner.name,
      getStatus(row.approvalStatus),

    )

    if (selectMultiMerchant.customFields) {
      Object.keys(arrayCustomFieldReimbursement).forEach((field) => {
        const type = arrayCustomFieldReimbursement[field].type
        const formattedField = formatCustomField(row, field, type, user!)

        if (type === 'invoice_reminder') {
          temp_excel.push(...formattedField)
        } else {
          temp_excel.push(formattedField)
        }
      })
    }

    if (user) {
      if (
        user!.data.company_id === '7763fccc-af52-43e1-8907-4678ab2423d1' &&
        comapnyCodeIndex !== -1 &&
        comapnyNameIndex !== -1
      ) {
        sortColumnDatatable(temp_excel, comapnyCodeIndex, nameIndex1)
        sortColumnDatatable(temp_excel, comapnyNameIndex, nameIndex2)
      }
    }

    exportData.push(temp_excel)
  })

  addDataRows(
    worksheet,
    exportData,
    source,
    header,
    columns!,
    intl,
    selectMultiMerchant,
    user,
    arrayCustomFieldReimbursement
  )

  setColumnWidths(worksheet, source, arrayCustomFieldReimbursement, exportData)
  styleColumns(worksheet, 1)
  exportWorkbook(workbook, source, `${nameFile}.xlsx`)
}

const createWorkbook = () => {
  const workbook = new ExcelJS.Workbook()
  workbook.creator = 'Looyal'
  workbook.lastModifiedBy = 'Looyal'
  workbook.created = new Date()
  workbook.modified = new Date()
  return workbook
}

const createWorksheet = (
  workbook: ExcelJS.Workbook,
  source: string,
  sheetName: string = 'Sheet1'
) => {
  let worksheet
  worksheet = workbook.addWorksheet(sheetName)
  return worksheet
}

const addDataRows = (
  worksheet: ExcelJS.Worksheet,
  data: any[],
  source: string,
  header: string[],
  columns: CRMColumnDef<Merchant>[],
  intl: IntlShape,
  selectMultiMerchant: SettingMultiMerchants,
  user?: UserModel,
  fields?: any
) => {
  if (source === 'Merchant') {
    // Set Data Body
    data.forEach((rowData, index) => {
      const row = worksheet.addRow(rowData)
      // Adjust cell styling if needed

      row.eachCell((cell, colIndex) => {
        cell.alignment = {
          vertical: 'top',
          wrapText: true,
          shrinkToFit: true,
        }

        const offsetColumns = 13

        if (colIndex > offsetColumns) {
          const fieldIndex = colIndex - offsetColumns - 1
          const fieldId = Object.keys(fields)[fieldIndex]

          if (fieldId && fields[fieldId].type === 'number') {
            cell.numFmt = '#,##0;[Red]-#,##0'
          }
        }
      })
    })

    // Dynamic column
    const columnIndicesToRemove: number[] = []
    if (user?.data.company_id === '7763fccc-af52-43e1-8907-4678ab2423d1')
      columnIndicesToRemove.push(3)

    // Cari semua indeks kolom yang perlu dihapus
    header.forEach((item, headerIndex) => {
      // console.log('header',item)
      if (
        selectMultiMerchant.isFeatureLabelEnabled == false &&
        item === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LABEL' })
      ) {
        columnIndicesToRemove.push(headerIndex + 1)
      }

      columns.forEach((column) => {
        if (column.excelColumnHidden && item === column.header) {
          columnIndicesToRemove.push(headerIndex + 1) // +1 untuk 1-based index
        }
      })
    })

    // Hapus kolom dari worksheet berdasarkan indeks yang ditemukan
    columnIndicesToRemove
      .sort((a, b) => b - a)
      .forEach((index) => {
        worksheet.spliceColumns(index, 1)
      })
  } else {
    // Set Data Body
    data.forEach((rowData, index) => {
      worksheet.addRow(rowData)
    })
  }
}
const setColumnWidths = (
  worksheet: ExcelJS.Worksheet,
  source: string,
  fields: any[],
  data: any
) => {
  const colWidths = [
    30,
    30,
    30,
    30,
    30,
    30,
    30,
    30,
    30,
    ...Object.keys(fields).map((field) => 25),
  ]
  worksheet.columns = colWidths.map((width) => ({ width }))
}


